
// change header background
// siteWrap = document.querySelector('.hero');
// siteWrapTop = 0;
// gridEl = document.querySelector('.gridPanel');
// gridElTop = 0;

// if (siteWrap){

//   siteWrapTop = window.pageYOffset + siteWrap.getBoundingClientRect().top;

// }

// if ( document.body.querySelector('.site-header') ) {

//   headerEl = document.body.querySelector('.site-header');

//   window.addEventListener('scroll', function(){
  
//     var scrolledDistance = window.pageYOffset - 60;
  
//     if (scrolledDistance >= siteWrapTop || scrolledDistance >= gridElTop){
  
//       headerEl.classList.add('changeHeader');	
  
//     } else {
  
//       headerEl.classList.remove('changeHeader');	
//     }	
  
//   });
  
// }

document.addEventListener('DOMContentLoaded', function(event) {
  
  // opening and closing menu
  var navButtonEl = document.body.querySelectorAll('[data-action="toggleNav"]');
  
  //console.log(navButtonEl);
  
  for (var i = 0; i < navButtonEl.length; i++) {
  
    navButtonEl[i].addEventListener('click', function() {
  
      if (document.body.classList.contains('show')) {
  
        document.body.classList.remove('show');
  
      } else {
  
        document.body.classList.add('show');
      }
    });
  }
  
  // opening and closing menu
  if (soldOutEl = document.body.querySelector('[data-action="soldOut"]')){
  
    var waitingList = document.body.querySelector('.waitingList');
   //console.log('here');
  
    soldOutEl.addEventListener('click', function() {
  
      waitingList.style.display = 'block';
  
    });
  
  }
  
  const swiper = new Swiper('.swiper-container', {
    loop: true,
    speed: 800,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

});

if(el = document.body.querySelector('.faqs')){
  
var showMore = document.body.querySelectorAll('.question h3');

for (var i = 0; i < showMore.length; i++) {
		
	showMore[i].addEventListener('click', function(event) {
			
		var parentEl = this.parentElement.querySelector('.question');
	
		if (this.parentElement.classList.contains('active')) {	  
			this.parentElement.classList.remove('active');
			
		} else {
			
			this.parentElement.classList.add('active');
		}
	});
}
}

if ( !document.querySelector('.hero') ) {

  var siteHeader = document.querySelector('.site-header');

  if (siteHeader && ! siteHeader.classList.contains('changeHeader') ) {
    siteHeader.classList.add('changeHeader');
  }
}